import React, { useRef, useState } from 'react';
import {
  Alert, Button, Modal, ModalBody, ModalCloseButton, ModalContent,
  ModalFooter, ModalHeader, ModalOverlay, Text,
} from '@chakra-ui/react';
import { AdminAlertIcon, CloseIcon } from './AdminIcon';
import AdminState from './AdminState';
import useAdminToast from './useAdminToast';
import Backend from '../../utils/api';
import { useAnimationToggle } from '../../Contexts/AnimationContext';

export default function RemoveBadgeRequirementDialog({ requirement, user, onClose, onRemoved, finalFocusRef }) {
  const cancelRef = useRef(null);
  const pendingRef = useRef(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState(false);
  const toast = useAdminToast();
  const { animationsEnabled } = useAnimationToggle();
  const close = () => { if (!pendingRef.current) onClose(); };
  const remove = async () => {
    if (!user.isSuperAdmin || pendingRef.current) return;
    pendingRef.current = true;
    setPending(true);
    setError(false);
    try {
      const response = await Backend.deleteBadgeRequirement(user.UID, requirement.id);
      if (!response || response.error || ![200, 204].includes(response.status)) throw new Error('remove_failed');
      toast({ title: 'Badge requirement removed', description: `${requirement.badge_name || requirement.badgeclass_entity_id} removed from ${requirement.name}.` });
      onRemoved();
    } catch {
      pendingRef.current = false;
      setPending(false);
      setError(true);
    }
  };
  return <Modal isOpen onClose={close} initialFocusRef={cancelRef} finalFocusRef={finalFocusRef}
    isCentered size="lg" scrollBehavior="inside" closeOnEsc={!pending} closeOnOverlayClick={!pending}
    motionPreset={animationsEnabled ? 'scale' : 'none'}>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>Remove badge requirement</ModalHeader>
      <ModalCloseButton aria-label="Close removal dialog" isDisabled={pending}><CloseIcon /></ModalCloseButton>
      <ModalBody>
        <Text mb={4}>Remove <strong>{requirement.badge_name || requirement.badgeclass_entity_id}</strong> as a requirement for <strong>{requirement.name}</strong>?</Text>
        <Alert status="warning" mb={4}><AdminAlertIcon status="warning" />This changes the tool’s badge requirements across all spaces.</Alert>
        <Text color="gray.600">The badge and badges already earned by users will remain in Parchment Digital Badges.</Text>
        {error && <AdminState status="error" mt={4} mb={0} title="Badge requirement could not be removed"
          description="The requirement is still listed. Try again." />}
      </ModalBody>
      <ModalFooter>
        <Button ref={cancelRef} variant="outline" onClick={close} isDisabled={pending}>Cancel</Button>
        <Button colorScheme="red" variant="solid" onClick={remove} isDisabled={!user.isSuperAdmin}
          isLoading={pending} loadingText="Removing…">Remove requirement</Button>
      </ModalFooter>
    </ModalContent>
  </Modal>;
}
